import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ResponseService } from '../../core/models/response-service.model';
import {
	AddBlackoutday,
	EditBlackoutday,
} from '../../core/models/blackoutday.models';
import { UtilsService } from '../utils/utils.service';

@Injectable({
	providedIn: 'root',
})
export class BlackoutdayService {
	url: string = '';
	constructor(private http: HttpClient, private utils: UtilsService) {}

	saveBlackOutDay(payload) {
		this.url = `${environment.api}blackoutday/save_blackoutday`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post<ResponseService>(this.url, formData);
	}

	getBlackOutDays(payload) {
		this.url = `${environment.api}blackoutday/get_black_out_days`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post<ResponseService>(this.url, formData);
	}

	getCampaignBlackOutDays(campaign_id: number) {
		this.url = `${environment.api}blackoutday/${campaign_id}/get_campaign_black_out_days`;
		return this.http.get<ResponseService>(this.url);
	}

	public getBlackOutDayHistory(black_out_day_id) {
		this.url = `${environment.api}blackoutday/${black_out_day_id}/get_history`;
		return this.http.get<ResponseService>(this.url);
	}

	update(blackoutDay: EditBlackoutday) {
		var formData: any = new FormData();
		formData.append('UserId', blackoutDay.UserId);
		formData.append('StartDateTime', blackoutDay.StartDateTime);
		formData.append('EndDateTime', blackoutDay.EndDateTime);
		formData.append('Reason', blackoutDay.Reason);
		formData.append('Id', blackoutDay.Id);

		this.url = `${environment.api}blackoutday/edit_blackoutday`;
		var response = this.http.post<ResponseService>(this.url, formData);

		return response;
	}

	changeState(payload){
		this.url = `${environment.api}blackoutday/change_state`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post<ResponseService>(this.url, formData);
	}
}
